import * as z from "zod";

/** One Recognize category — a criterion, plus its members in aggregate. */
export const RecognizeCategory = z.object({
  /** Criterion key. Stable across renames, and what the VIPs filter matches. */
  key: z.string(),
  name: z.string(),
  vips: z.number(),
  /** Whole USD. */
  emv: z.number(),
  reach: z.number(),
  /** Members added within `momentumWindowDays`. */
  momentum: z.number(),
});
export type RecognizeCategory = z.infer<typeof RecognizeCategory>;

export const getRecognizeCategories = {
  name: "getRecognizeCategories" as const,
  input: z.object({}),
  output: z.object({
    categories: z.array(RecognizeCategory),
    momentumWindowDays: z.number(),
  }),
};
